import axios from "axios";

export function createRateLimitedAxios() {
  let resetAt = 0;
  let remaining = Infinity;

  async function rateLimitedAxios(config) {
    // Check if we hit the limit
    if (remaining <= 0 && resetAt > Date.now()) {
      const wait = resetAt - Date.now();
      return new Promise((resolve) => setTimeout(resolve, wait));
    }

    try {
      const res = await axios(config);

      if (res.headers["ratelimit-remaining"] !== undefined) {
        remaining = parseInt(res.headers["ratelimit-remaining"]);
      }
      if (res.headers["ratelimit-reset"] !== undefined) {
        const reset = parseInt(res.headers["ratelimit-reset"], 10);
        resetAt = Date.now() + reset * 1000;
      }

      return res;
    } catch (err) {
      // If the response is due to rate limiting, handle it here
      if (err.response && err.response.status === 429) {
        const retryAfter =
          parseInt(err.response.headers["retry-after"], 10) || 1;
        await new Promise((resolve) => setTimeout(resolve, retryAfter * 1000));
        return rateLimitedAxios(config);
      }
      // Otherwise throw the error up the chain
      throw err;
    }
  }

  return rateLimitedAxios;
}
